var React = require('react');

function CarBattery (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M176 64H80a16 16 0 0 0-16 16v48h128V80a16 16 0 0 0-16-16zm256 0h-96a16 16 0 0 0-16 16v48h128V80a16 16 0 0 0-16-16z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M480 128H32a32 32 0 0 0-32 32v256a32 32 0 0 0 32 32h448a32 32 0 0 0 32-32V160a32 32 0 0 0-32-32zM192 264a8 8 0 0 1-8 8H72a8 8 0 0 1-8-8v-16a8 8 0 0 1 8-8h112a8 8 0 0 1 8 8zm256 0a8 8 0 0 1-8 8h-40v40a8 8 0 0 1-8 8h-16a8 8 0 0 1-8-8v-40h-40a8 8 0 0 1-8-8v-16a8 8 0 0 1 8-8h40v-40a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v40h40a8 8 0 0 1 8 8z","className":"fa-primary","key":2})]);
}

CarBattery.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = CarBattery;

CarBattery.default = CarBattery;
